module.exports = __webpack_public_path__ + "img/TECHNOLOGY-FRONX-BOOSTERGREEN-4.9b10b9b1.jpg";